<template>
    <div id="columnSetting">

    </div>
</template>
<script>
    export default{
        data(){
            return{
                visible:false,
                editTableData: []
            }
        }
    }
</script>